import getRequestsNetworkSelector from 'modules/training/modules/network/selectors/get-requests'
import setReduxAction from 'modules/redux/actions/set'
import { NETWORK_ACTION, NETWORK_PATH } from 'modules/training/modules/network/constants'

function markRequestsAsNotSaving () {
  return (dispatch, getState) => {
    const requests = getRequestsNetworkSelector()(getState())
    const statusPaths = []
    const newRequests = requests.map(request => {
      if (request.isSaving === true) {
        statusPaths.push(request.payload.path + '.status')
      }
      return {
        ...request,
        isSaving: false
      }
    }, {})
    if (!statusPaths.length) {
      return
    }
    dispatch(
      setReduxAction({
        type: NETWORK_ACTION.DELETE_SAVING_REQUESTS_STATUS,
        payload: {
          path: NETWORK_PATH.REQUESTS,
          value: newRequests
        }
      })
    )
    dispatch(
      setReduxAction({
        type: NETWORK_ACTION.DELETE_SAVING_REQUESTS_MODELS_STATUS,
        payload: {
          paths: statusPaths,
          value: statusPaths.map(() => null)
        }
      })
    )
  }
}

export default markRequestsAsNotSaving
